import { supabase } from '../../../lib/supabase';
import type { Post } from '../../../types/blog';
import { PostgrestFilterBuilder } from '@supabase/postgrest-js';

export async function getPosts() {
  try {
    console.log('Fetching posts...');
    const { data: { session } } = await supabase.auth.getSession();
    
    const baseQuery = supabase
      .from('posts')
      .select('*');

    // 如果未登录，只显示已发布的文章
    const query = !session 
      ? (baseQuery as PostgrestFilterBuilder<any, any, any>).eq('status', 'published')
      : baseQuery;
    
    const { data, error } = await query.order('created_at', { ascending: false });
    
    if (error) {
      console.error('Error fetching posts:', error);
      throw error;
    }
    
    console.log('Posts fetched successfully:', data?.length || 0, 'posts');
    return data as Post[];
  } catch (err) {
    console.error('Failed to fetch posts:', err);
    throw err;
  }
}

export async function getPublicPosts() {
  try {
    console.log('Fetching public posts...');
    const { data, error } = await supabase
      .from('posts')
      .select('*')
      .eq('status', 'published')
      .order('created_at', { ascending: false });
    
    if (error) {
      console.error('Error fetching public posts:', error);
      throw error;
    }
    
    console.log('Public posts fetched successfully:', data?.length || 0, 'posts');
    return data as Post[];
  } catch (err) {
    console.error('Failed to fetch public posts:', err);
    throw err;
  }
}

export async function getPost(slug: string) {
  try {
    console.log('Fetching post by slug:', slug);
    const { data: { session } } = await supabase.auth.getSession();
    
    const baseQuery = supabase
      .from('posts')
      .select('*')
      .eq('slug', slug)
      .single();

    // 如果未登录，只显示已发布的文章
    const query = !session 
      ? (baseQuery as PostgrestFilterBuilder<any, any, any>).eq('status', 'published')
      : baseQuery;
    
    const { data, error } = await query;
    
    if (error) {
      console.error('Error fetching post:', error);
      throw error;
    }
    
    console.log('Post fetched successfully:', data);
    return data as Post;
  } catch (err) {
    console.error('Failed to fetch post:', err);
    throw err;
  }
}

export async function getPostById(id: string) {
  try {
    console.log('Fetching post by id:', id);
    const { data: { session } } = await supabase.auth.getSession();
    
    const baseQuery = supabase
      .from('posts')
      .select('*')
      .eq('id', id)
      .single();

    // 如果未登录，只显示已发布的文章
    const query = !session 
      ? (baseQuery as PostgrestFilterBuilder<any, any, any>).eq('status', 'published')
      : baseQuery;
    
    const { data, error } = await query;
    
    if (error) {
      console.error('Error fetching post:', error);
      throw error;
    }
    
    console.log('Post fetched successfully:', data);
    return data as Post;
  } catch (err) {
    console.error('Failed to fetch post:', err);
    throw err;
  }
}

export async function createPost(post: Omit<Post, 'id' | 'created_at' | 'updated_at'>) {
  try {
    console.log('Creating post...');
    const { data, error } = await supabase
      .from('posts')
      .insert([post])
      .select()
      .single();

    if (error) {
      console.error('Error creating post:', error);
      throw error;
    }
    
    console.log('Post created successfully:', data);
    return data as Post;
  } catch (err) {
    console.error('Failed to create post:', err);
    throw err;
  }
}

export async function updatePost(id: string, post: Partial<Post>) {
  try {
    console.log('Updating post by id:', id);
    const { data, error } = await supabase
      .from('posts')
      .update(post)
      .eq('id', id)
      .select()
      .single();

    if (error) {
      console.error('Error updating post:', error);
      throw error;
    }
    
    console.log('Post updated successfully:', data);
    return data as Post;
  } catch (err) {
    console.error('Failed to update post:', err);
    throw err;
  }
}

export async function updatePostStatus(id: string, status: 'draft' | 'published') {
  try {
    console.log('Updating post status by id:', id);
    const { data, error } = await supabase
      .from('posts')
      .update({ status })
      .eq('id', id)
      .select()
      .single();

    if (error) {
      console.error('Error updating post status:', error);
      throw error;
    }
    
    console.log('Post status updated successfully:', data);
    return data as Post;
  } catch (err) {
    console.error('Failed to update post status:', err);
    throw err;
  }
}